import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'

export const useDrawerHeaderOverlayStyles = makeStyles((theme: Theme) => ({
  menuOverlay: {
    display: 'flex',
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 1310, // 1200 -> zIndex appbar | 1300 -> zIndex drawer
    alignItems: 'center',
    width: theme.custom?.drawerWidthLarge,

    paddingTop: 0,
    paddingBottom: 0,
    minHeight: 64, // copied from appbar styles - this probably gets defined in the theme, but iam not sure where
  },
  menuOverlayHeightMobile: {
    minHeight: 56, // copied from appbar styles - this probably gets defined in the theme, but iam not sure where
  },
  menuOverlaySmall: {
    width: (theme.custom?.drawerWidthSmall || 0) * 2,
    transition: theme.transitions.create(['width', 'left'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  menuOverlayLarge: {
    width: theme.custom?.drawerWidthLarge,
    transition: theme.transitions.create(['width', 'left'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuOverlayItem: {
    position: 'relative',
    display: 'flex',
    height: '100%',
    paddingTop: 0,
    paddingBottom: 0,
  },
  menuOverlayItemSmall: {
    width: theme.custom?.drawerWidthSmall,
    transition: theme.transitions.create(['width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  menuOverlayItemLarge: {
    width: (theme.custom?.drawerWidthLarge || 0) / 2,
    transition: theme.transitions.create(['width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuOverlayItemLeft: {
    justifyContent: 'flex-start',
  },
  menuOverlayItemRight: {
    justifyContent: 'flex-end',
  },
  iconStackContainer: {
    position: 'relative',
  },
  stackedIcon: {
    position: 'absolute',
  },
  menuIcon: {
    opacity: 1,
    transition: theme.transitions.create(['opacity', 'color'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.shorter,
    }),
  },
  siteLogoContainer: {
    position: 'relative',
    height: theme.custom?.drawerIconHeight || 40,
    width: '100%',
  },
  siteLogo: {
    position: 'absolute',
    height: theme.custom?.drawerIconHeight || 40,
    top: 0,
    left: 0,
    opacity: 1,
    transform: 'translateX(0)',
    transition: theme.transitions.create(['left', 'transform', 'opacity'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.leavingScreen,
    }),
    pointerEvents: 'none',
  },
  siteLogoRight: {
    left: '100%',
    transform: 'translateX(-100%)',
    transition: theme.transitions.create(['left', 'transform', 'opacity'], {
      easing: theme.transitions.easing.easeIn,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  elementHidden: {
    opacity: 0,
    // opacity transitions need to be handled in other classes
    // adding opacity transition here would override other transition types
  },
  whiteIcon: {
    '& *': {
      fill: '#fff !important',
      stroke: '#fff !important',
    },
  },
}))
